module.exports = __webpack_public_path__ + "img/document.f039f32c.svg";